module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAABGdBTUEAALGPC/xhBQAAAGBJREFUWAnt1bsJACAMRVHjStl/hMykXYpHGj+gxbUyAUVOwGfuPlqxIsKKdrZun+t58+MND9EBIKIi1AgggMCpgN1O0d3U5ovXUSLyrYg+jBoBBBBYFSB9VYzQQ0QFtJ4EExzqbH3hTgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activityBoard.png
// module id = i3Y/
// module chunks = 1